import useAlertAdd from "@@/composables/alert/useAlertAdd.js";

export default () => {
	const setBackendValidation = (actions, result) => {
		if (!actions || !result) {
			return false;
		}

		const { addErrorAlert } = useAlertAdd();

		const { setFieldError, controlledValues } = actions;

		if (result?.response?.data?.errors) {
			Object.keys(result.response.data.errors).forEach((key) => {
				const messages = result.response.data.errors[key];

				if ("object" === typeof controlledValues && key in controlledValues) setFieldError(key, messages.join(" "));

				addErrorAlert(messages.join(" "));
			});
		}
	};

	return { setBackendValidation };
};
